import React from 'react'
import { connect } from 'react-redux';
import MainHorizontalNav from './MainHorizontalNav'
import MainMobileNav from './MainMobileNav'
import AccountNavigation from './AccountNavigation'

class Header extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, menuItems, alertMessage, logoLink } = this.props;

        return (
            <header id="header">
                <div id="header_top" className="navbar navbar-fixed-top">
                    <div style={{display:"flex", alignItems:"center", minHeight:"42px"}}>
                        <div id="logo">
                            <a title="Reico Kitchen &amp; Bath" href="/">
                                <img src={logoLink} alt="Reico Kitchen &amp; Bath - Salesforce" />
                            </a>
                        </div>
                        {
                            !!alertMessage && <div className="header-alert alert-warning">{alertMessage}</div>
                        }
                        <div style={{marginLeft:"auto"}}>
                            {/* Account Navigation */}
                            <AccountNavigation dispatch={dispatch} />
                        </div>

                        <MainMobileNav menuItems={menuItems} />
                    </div>
                </div>
                <div id="header_bottom">
                    <MainHorizontalNav menuItems={menuItems} />
                 </div>
            </header>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    menuItems: ownProps.menuItems,
    alertMessage: ownProps.alertMessage
 });

export default connect(mapStateToProps)(Header);